import styled, { css } from 'styled-components';
import { StatusTagType } from '../ThemeProvider/types';
import { TagHierarchyType } from './types';

export const TagContainer = styled.div<{
  hierarchy: TagHierarchyType;
  status: StatusTagType;
  fullWidth: boolean;
  hasIcon: boolean;
}>`
  align-items: center !important;
  border: 1px solid;
  border-radius: ${({ hierarchy }) => (hierarchy === 'highlight' ? '10px' : '4px')};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  font-family: 'Mulish', sans-serif;
  gap: ${({ hasIcon }) => (hasIcon ? '6px' : '0')};
  justify-content: center !important;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};

  ${({ hierarchy, theme, status }) =>
    hierarchy === 'standard'
      ? css`
          font-size: 14px;
          font-weight: 400;
          padding: 4px 12px;
          background-color: ${theme.status[status].background};
          border-color: ${theme.status[status].default};
          color: ${theme.gray2D};
        `
      : css`
          font-size: 14px;
          font-weight: 700;
          padding: 4px 12px;
          background-color: ${theme.status[status].background};
          border-color: ${theme.status[status].default};
          color: ${theme.status[status].default};
        `}
`;

export const TagIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
  color: inherit;
`;
